import React from "react";
import { CommentsListNameProps } from "./comments-list-name.props";
import { HostContainer } from "./comments-list-name.styles";

export const CommentsListName = (props: CommentsListNameProps) => (
  <HostContainer>
    {props.comment.user.firstName +' '+ props.comment.user.lastName}{" "}
    {props.currentUser.id === props.comment.user.id ? "(You)" : ""}
  </HostContainer>
);
